export default __webpack_public_path__ + "static/media/failed-empty.1b32730c.svg";